module.exports = __webpack_public_path__ + "3b177be5e32b4a5ea46a5d9e125405e3.png";